import React, { useState, useEffect } from 'react';
import ProFormaSideNav from 'views/ProFormaTable/components/ProFormaSideNav/ProFormaSideNav';
import ProForma from 'views/ProFormaTable/components/ProForma/ProForma';
import { PRO_FORMA_TABLE_NAV, PRO_FORMA_TABS } from 'views/ProFormaTable/constants';
import { SignUpStage, useSignUpContext } from '../SignUp/SignUpContext';
import { ProFormaQuickStartValues } from '../ProFormaQuickStart/types';
import useSignUpManager from '../SignUp/useSignUpManager';

const ProFormaDashboard = () => {
    const { setCurrentStage, stageData, updateStageData } = useSignUpContext();
    const storedStageData = stageData[SignUpStage.PRO_FORMA_QUICK_START] as ProFormaQuickStartValues;

    const [currentTab, setCurrentTab] = useState<string>(PRO_FORMA_TABS.GENERAL_INFORMATION.name);
    const [proFormaSignUpData, setProFormaSignUpData] = useState(storedStageData);

    const [displayManualSignUp, setDisplayManualSignUp] = useState(false);
    const signUpManager = useSignUpManager();

    useEffect(() => {
        signUpManager.setRedirectUrlAfterPasswordReset(`${window.location.origin}/account_created`);
    }, [signUpManager.setRedirectUrlAfterPasswordReset]);

    const activeSideNav = PRO_FORMA_TABLE_NAV.PRO_FORMA.name;

    const navigateToProFormaQuickStart = () => {
        updateStageData(proFormaSignUpData, SignUpStage.PRO_FORMA_QUICK_START);
        setCurrentStage(SignUpStage.PRO_FORMA_QUICK_START);
    };

    const handleTabChange = (sideNavName: string, tabName: string | undefined) => {
        if (tabName) {
            setCurrentTab(tabName);
            updateStageData(proFormaSignUpData, SignUpStage.PRO_FORMA_QUICK_START);
        }
    };

    return (
        <div className="d-flex align-items-stretch p-3">
            <div className="flex-shrink-0">
                <ProFormaSideNav
                    activeNav={activeSideNav}
                    navigateToSection={() => { }}
                    hasWriteAccessToProForma={false}
                    signUpMode
                    signUpManager={signUpManager}
                    navigateToProFormaQuickStart={navigateToProFormaQuickStart}
                    currentTab={currentTab}
                    setCurrentTab={setCurrentTab}
                    setDisplayManualSignUp={setDisplayManualSignUp!}
                />
            </div>
            <div className="flex-grow-1 overflow-hidden ml-3">
                <ProForma
                    navigateToSection={handleTabChange}
                    currentSection={activeSideNav}
                    currentTab={currentTab}
                    hasWriteAccessToProForma={false}
                    signUpMode
                    proFormaSignUpData={proFormaSignUpData}
                    setProFormaSignUpData={setProFormaSignUpData}
                    displayManualSignUp={displayManualSignUp}
                    setDisplayManualSignUp={setDisplayManualSignUp}
                    signUpManager={signUpManager}
                />
            </div>
        </div>
    );
};

export default ProFormaDashboard;
